import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Card, Badge } from '@themesberg/react-bootstrap';
import { get } from '../../services/back.service';

const years = [2020, 2021, 2022, 2023, 2024, 2025];
const months = [
  { value: 1, name: "Enero" },
  { value: 2, name: "Febrero" },
  { value: 3, name: "Marzo" },
  { value: 4, name: "Abril" },
  { value: 5, name: "Mayo" },
  { value: 6, name: "Junio" },
  { value: 7, name: "Julio" },
  { value: 8, name: "Agosto" },
  { value: 9, name: "Septiembre" },
  { value: 10, name: "Octubre" },
  { value: 11, name: "Noviembre" },
  { value: 12, name: "Diciembre" }
];

const DateSelectorComponent = ({ processFilter }) => {
  const defaultYear = new Date().getFullYear();
  const defatulMonth = new Date().getMonth() + 1;
  const [selectedYears, setSelectedYears] = useState([defaultYear]);
  const [selectedMonths, setSelectedMonths] = useState([defatulMonth]);
  const [dateRange, setDateRange] = useState(['', '']);
  const [offices, setOffice] = useState([]);
  const [selectOffice, setSelectOffice] = useState('');
  const [startDate, endDate] = dateRange;

  const handleYearChange = ({ target }) => {
    const selectedYear = target.value;
    if (selectedYear && !selectedYears.includes(selectedYear)) {
      setSelectedYears([...selectedYears, selectedYear]);
    }
  };

  const handleMonthChange = ({ target }) => {
    const selectedMonthValue = parseInt(target.value);
    if (selectedMonthValue && !selectedMonths.includes(selectedMonthValue)) {
      setSelectedMonths([...selectedMonths, selectedMonthValue]);
    }
  };

  const handleInitChange = ({ target }) => {
    const newStartDate = target.value;

    if (endDate && newStartDate > endDate) {
      setDateRange([endDate, newStartDate]);
    } else {
      setDateRange([newStartDate, endDate]);
    }
  };

  const handleEndChange = ({ target }) => {
    const newEndDate = target.value;
    if (startDate && newEndDate < startDate) {
      setDateRange([newEndDate, startDate]);
    } else {
      setDateRange([startDate, newEndDate]);
    }
  };

  const handleOfficeChange = ({ target }) => {
    setSelectOffice(target.value)
  }


  const removeYear = (yearToRemove) => {
    setSelectedYears(selectedYears.filter(year => year !== yearToRemove));
  };

  const removeMonth = (monthToRemove) => {
    setSelectedMonths(selectedMonths.filter(month => month !== monthToRemove));
  };

  useEffect(() => {
    const response = {
      years: selectedYears,
      months: selectedMonths,
      dateIni: dateRange[0],
      dateEnd: dateRange[1],
      office: selectOffice,
    }
    processFilter(response)
  }, [selectedYears, selectedMonths, dateRange, selectOffice, processFilter])

  useEffect(() => {
    const getOffice = async () => {
      const responseoffice = await get('/office/', {});
      if (responseoffice.success) {
        setOffice(responseoffice.data);
      }
    };
    getOffice()
  }, [])

  return (
    <Form>
      <Row>
        <Col md={4}>
          <Form.Group controlId="yearSelector">
            <Form.Label>Sucursal</Form.Label>
            <Form.Control as="select" onChange={handleOfficeChange}>
              <option value=''>Seleccione Sucursal</option>
              {offices.map(office => (
                <option key={office.id} value={office.id}>{office.name}</option>
              ))}
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group controlId="yearSelector">
            <Form.Label>Año</Form.Label>
            <Form.Control as="select" onChange={handleYearChange}>
              <option value=''>Seleccione año</option>
              {years.map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group controlId="monthSelector">
            <Form.Label>Mes</Form.Label>
            <Form.Control as="select" onChange={handleMonthChange}>
              <option value=''>Seleccione mes</option>
              {months.map((month, index) => (
                <option key={index} value={month.value}>{month.name}</option>
              ))}
            </Form.Control>
          </Form.Group>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col>
          <Form.Group>
            <Form.Label>Fecha Inicio</Form.Label>
            <Form.Control
              name="init_date"
              value={startDate}
              type="date"
              onChange={handleInitChange}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group>
            <Form.Label>Fecha Fin</Form.Label>
            <Form.Control
              name="end_date"
              value={endDate}
              type="date"
              onChange={handleEndChange}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col>
          <Card className="mx-auto">
            <Card.Body>
              <Card.Text>
                <strong>Años:</strong>
                {selectedYears.length > 0 ? (
                  selectedYears.map(year => (
                    <Badge key={year} bg="primary" className='m-1' onClick={() => removeYear(year)}>
                      {year} X
                    </Badge>
                  ))
                ) : (
                  'None selected'
                )}
                <br />
                <strong>Meses:</strong>
                {selectedMonths.length > 0 ? (
                  selectedMonths.map(value => {
                    const month = months.find(month => month.value === parseInt(value));
                    return (
                      <Badge key={value} bg="primary" className="m-1" onClick={() => removeMonth(value)}>
                        {month?.name} X
                      </Badge>
                    );
                  })
                ) : (
                  'None selected'
                )}
                <br />
                <strong>Rango Fechas:</strong> {startDate || 'Not set'} - {endDate || 'Not set'}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Form>
  );
};

export default DateSelectorComponent;
